/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/storage-api';
}

/**
 * Parameters for `StorageApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
